import React from 'react';
import {
  TextLink,
  TextLinkProps,
} from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import classNames from 'classnames';
import styles from './LinkAsColumn.scss';

const LinkAsColumn = ({ className, ...textLinkProps }: TextLinkProps) => {
  return <TextLink className={classNames(styles.column, className)} {...textLinkProps} />;
};

export default LinkAsColumn;
